import { sendPost } from "src/utils/sendApi";

export const fileUploadApi = sendPost(
  "v1/data/_fileupload"
);
